module.exports = __webpack_public_path__ + "img/delivery-small.738a2b2c.svg";